import React, { useState } from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Layout } from 'components/Layout';
import { getPageStaticProps } from 'lib/dato-request';
import IconBlock from '@/components/Animations/IconBlock';
import FormSetup from '@/components/FormSetup/FormSetup';
import LargeHeading from '@/components/Views/Heading';
import { LargeText } from '@/components/Views/Text';
import SetupSSo from '@/components/SetupSSO/SetupSSo';
const SetupPage = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    const [signUpToken, setToken] = useState({ email: null });

    const desktopFloatingHeartsPositions = [
        { top: '6%', left: '1%', rotate: 22, scale: 0.7, opacity: 1 },
        { top: '6%', left: '94%', rotate: 344, scale: 1.2, opacity: 1 },
        { top: '93%', left: '93%', rotate: 25, scale: 0.7, opacity: 1 }
    ];

    return (
        <Layout showClassCodeInput={false} hideNavigationMenu={true} showLoginAndSignup={false}>
            <NextSeo title={seo?.title ?? page.slug} description={seo?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>
            <div className='bg-white font-Inter relative  pt-[80px] xl:pt-[110px]'>
                <div className='w-full relative' id='setup-form'>
                    <div className='max-w-[1000px] mx-auto -bg-blue-400 z-0 bg-no-repeat bg-top bg-contain absolute left-0 right-0 top-[0] bottom-[0] bg-[url("/backgrounds/bg-setup.svg")] ' />
                    <div className='relative z-10 pb-6'>
                        <div className='relative z-20 w-full mx-auto default-px'>
                            <LargeHeading as='h1' className='lg:text-center font-bold' balanced={true}>
                                Create your Muzology Parent Account
                            </LargeHeading>
                            <LargeText className='text-[#4B5563] text-center font-[600] mt-4' balanced={true}>
                                Once logged in, you can set up your child's account.
                            </LargeText>
                        </div>
                        <div className='flex flex-col md:flex-row justify-center items-center px-4'>
                            <div className='w-full max-w-[550px]'>
                                <FormSetup className='mt-4' />
                            </div>
                            {/*
                            <div className='w-full max-w-[160px] text-center'>
                                <div className='text-[#3A3A3A] mx-4 lg:mx-8 text-4xl'>-OR-</div>
                            </div>
                            <div className='w-full max-w-[440px]'>
                                <SetupSSo />
                            </div>
                            */}
                        </div>
                    </div>
                    <IconBlock icons={desktopFloatingHeartsPositions} className='hidden lg:block z-0' />
                </div>

                <style jsx>{`
                    #setup-form {
                        background-image: url('/backgrounds/bg-wavy-2.png');
                        background-repeat: no-repeat, no-repeat;
                        background-size: 100%, 100%;
                        background-position: 80% 100%, center;
                    }
                `}</style>
            </div>
        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Subscription Setup');
}

export default SetupPage;
